import { AppInsightsProvider } from 'utils/telemetry/app-insights-provider';
import { Widget, WidgetCreationData } from 'containers/HomePageContainer/types';
import { api } from 'api/apibase.service';
import { getWidgetLayout } from 'containers/HomePageContainer/utils/get-widget-layout';
import { useGlobalAlertStore } from 'common/store/client/global-alert/use-global-alert.store';
import { useHomePageWidgetsStore } from 'containers/HomePageContainer/store/client/use-home-page-widgets.store';
import { useMutation } from '@tanstack/react-query';
import shallow from 'zustand/shallow';

interface CreateWidgetSuccessResponse<T> {
  data: T;
}

export const useCreateWidgetMutation = <T extends Widget>(
  closeModal: () => void,
) => {
  const widgets = useHomePageWidgetsStore((store) => store.widgets, shallow);
  const setWidgets = useHomePageWidgetsStore((store) => store.setWidgets);
  const openAlert = useGlobalAlertStore((store) => store.openAlert);

  return useMutation<CreateWidgetSuccessResponse<T>, Error, WidgetCreationData>(
    (data: WidgetCreationData) => api.base.put('/widgets', data),
    {
      onSuccess: ({ data }) => {
        setWidgets([
          ...(widgets || []),
          {
            id: data.id,
            widgetId: data.widgetId,
            name: data.name,
            type: data.type,
            layout: getWidgetLayout(data),
            sources: data.sources,
            activeFrom: data.activeFrom,
            activeTo: data.activeTo,
          },
        ]);
        openAlert({
          text: 'Widget was created successfully',
          severity: 'success',
        });
        closeModal();
      },
      onError: (error) => {
        AppInsightsProvider.trackError(error);
        openAlert({
          text: `Error occurred during creation, please try again. Error: ${String(error)}`,
          severity: 'error',
        });
      },
    },
  );
};
